import React from "react";
import { Card, Form, Row, Col, Button, Accordion, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const LeadershipMessagesSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const addMessage = () => {
    const newMessage = {
      isVisible: true,
      id: Date.now().toString(),
      title: "",
      message: "",
      author: "",
      designation: "",
      image: "",
      imagePosition: "left",
    };
    onUpdate([...data, newMessage]);
  };

  const removeMessage = (index) => {
    const updated = data.filter((_, i) => i !== index);
    onUpdate(updated);
  };

  const updateMessage = (index, field, value) => {
    const updated = data.map((item, i) => 
      i === index ? { ...item, [field]: value } : item
    );
    onUpdate(updated);
  };

  const handleImageUpload = async (index, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        updateMessage(index, 'image', res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Leadership Messages</h5>
        <Button variant="outline-primary" size="sm" onClick={addMessage}>
          Add Message
        </Button>
      </Card.Header>
      <Card.Body>
        <Accordion>
          {data.map((message, index) => (
            <Accordion.Item key={message.id || index} eventKey={index.toString()}>
              <Accordion.Header>
                Message {index + 1}: {message.title || "Untitled"}
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md={12} className="mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <Form.Check
                        type="checkbox"
                        checked={message.isVisible}
                        onChange={(e) => updateMessage(index, 'isVisible', e.target.checked)}
                        label="Visible"
                      />
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => removeMessage(index)}
                      >
                        Remove
                      </Button>
                    </div>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Title</Form.Label>
                      <Form.Control
                        type="text"
                        value={message.title}
                        onChange={(e) => updateMessage(index, 'title', e.target.value)}
                        placeholder="Enter title"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Image Position</Form.Label>
                      <Form.Select
                        value={message.imagePosition}
                        onChange={(e) => updateMessage(index, 'imagePosition', e.target.value)}
                      >
                        <option value="left">Left</option>
                        <option value="right">Right</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        value={message.message}
                        onChange={(e) => updateMessage(index, 'message', e.target.value)}
                        placeholder="Enter message"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Author</Form.Label>
                      <Form.Control
                        type="text"
                        value={message.author}
                        onChange={(e) => updateMessage(index, 'author', e.target.value)}
                        placeholder="Enter author name"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Designation</Form.Label>
                      <Form.Control
                        type="text"
                        value={message.designation}
                        onChange={(e) => updateMessage(index, 'designation', e.target.value)}
                        placeholder="Enter designation"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Image</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          e.target.files?.[0] && handleImageUpload(index, e.target.files[0])
                        }
                      />
                      {isUploading && (
                        <div className="text-muted small mt-1">
                          Uploading...
                        </div>
                      )}
                      {message.image && (
                        <div className="mt-2">
                          <Image
                            src={message.image}
                            alt="Preview"
                            thumbnail
                            style={{ maxWidth: "200px" }}
                          />
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Card.Body>
    </Card>
  );
};

export default LeadershipMessagesSection;
